// export const DICTIONARIES = 'SN_LBCS_BU_ID'; // LBCS事业部
export const DICTIONARIES = 'DIVISION_CODE';
export const LOUYU_DIVISION = ['11', '32', '24', '31', '25', '51', '42', 'M106']; // 楼宇事业
